<template>
  <div class="row">
    <div class="col-md-12" v-if="servicio.estado != 'Finalizado'">
      <div class="callout callout-success" :style="exportada == true?'background-color: lightgrey;':''" 
      :title="exportada == true?'Exportada en contabilidad':''">
        <div v-if="!cobrado" class="ribbon_no_cobrada ribbon-top-right"><span>{{$t('general.no cobrada')}}</span></div>
        <div v-if="cobrado" class="ribbon_cobrada ribbon-top-right"><span>{{$t('general.cobrada')}}</span></div>
        <div v-if="abono == false && cobrado" style="display: flex; gap: 20px;">          
          <h5 v-if="abono == false" style="cursor: pointer;" @click="copiarNum(factura.numero)">{{factura.error_xml?.valor == 1?'Registro':$t('general.factura')}} <strong>{{factura.numero}}</strong>
            <i style="margin-left: 5px;" v-if="exportada" class="fas fa-file-export"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 1" class="fas fa-check-circle" title="Env&iacute;o a VeriFactu CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoVeriFactu == 2" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 2 && factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO, Subsanada"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoVeriFactu == 3" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu: AceptadoConErrores"></i>
            <i style="margin-left: 5px; color: #7c7c7cff" v-if="factura.error_xml?.valor == 1" class="fas fa-exclamation-circle" :title="factura.error_xml?.texto"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoTBAI == 1" class="fas fa-check-circle" title="Env&iacute;o TBAI CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoTBAI == 2" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI INCORRECTO"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoTBAI == 3" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI: Pendiente"></i>
          </h5>
        </div>
        <div v-else-if="abono == false ">
          <h5 v-if="abono == false" style="cursor: pointer;" @click="copiarNum(factura.numero)">{{factura.error_xml?.valor == 1?'Registro':$t('general.factura')}} <strong>{{factura.numero}}</strong>
            <i style="margin-left: 5px;" v-if="exportada" class="fas fa-file-export"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 1" class="fas fa-check-circle" title="Env&iacute;o a VeriFactu CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoVeriFactu == 2" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 2 && factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO, Subsanada"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoVeriFactu == 3" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu: AceptadoConErrores"></i>
            <i style="margin-left: 5px; color: #7c7c7cff" v-if="factura.error_xml?.valor == 1" class="fas fa-exclamation-circle" :title="factura.error_xml?.texto"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoTBAI == 1"  class="fas fa-check-circle" title="Env&iacute;o TBAI CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoTBAI == 2"  class="fas fa-exclamation-circle" title="Env&iacute;o TBAI INCORRECTO"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoTBAI == 3"  class="fas fa-exclamation-circle" title="Env&iacute;o TBAI: Pendiente"></i>
          </h5>
        </div>
        <div v-if="abono == true">
          <h5 style="cursor: pointer;" @click="copiarNum(factura.numero)">Rectificativa <strong>{{factura.numero}}</strong>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 1" class="fas fa-check-circle" title="Env&iacute;o a VeriFactu CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoVeriFactu == 2" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 2 && factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO, Subsanada"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoVeriFactu == 3" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu: AceptadoConErrores"></i>
            <i style="margin-left: 5px; color: #7c7c7cff" v-if="factura.error_xml?.valor == 1" class="fas fa-exclamation-circle" :title="factura.error_xml?.texto"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoTBAI == 1" class="fas fa-check-circle" title="Env&iacute;o TBAI CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoTBAI == 2" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI INCORRECTO"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoTBAI == 3" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI: Pendiente"></i>
          </h5>
        </div>
        <div v-if="abono == false && cobrado" style="display: flex; gap: 20px; flex-wrap: wrap">    
          <div>
            <strong>Cliente: </strong>
            {{ factura.factura.nombre_cliente }}
          </div>
          <div style="display: flex; gap: 5px; align-items: center">
            <label for="">Fecha de cobro:</label>
            <h6 title="Fecha de cobro" >{{ fechapago }}
            </h6>
          </div>      
        </div>
        <div v-else class="row" style="margin: 0; gap:5px">
          <strong>Cliente: </strong>
          {{ factura.factura.nombre_cliente }}
        </div>
        <div class="row" style="margin-top: 15px;">
          <div class="col-md-4"><input type="date" @input="actualizarFecha()" :disabled="bloquearfecha"
              v-model="datosf.fecha_hoy" class="form-control input-xs"></div>
          <div class="col-md-4" style="display:flex;justify-content:flex-end;">
            <h4><span v-if="abono == true">-</span>{{ datosf.base_imponible }}&euro;</h4>
          </div>
          <div v-if="factura.tipos_iva" class="col-md-4" style="display:flex;justify-content:flex-end;">
            <h4>{{ factura.tipos_iva[0] }}%</h4>
          </div>
        </div>
        <div class="row" style="justify-content: end;">
          <div class="col-md-4">

          </div>
          <div class="col-md-9 btn-group" style="justify-content: end">
            <div class="input-group" style="width: auto;">
              <div class="input-group-prepend">
                <button v-if="factura.enviada_factura == 'NO'" type="button" class="btn btn-default" title="Enviar a axa"
                  @click="enviarAxa"><i class="fas fa-font"></i></button>
                <button v-if="documentosFactura && documentosFactura.length > 0" type="button" class="btn btn-default" title="Mostrar gestor de documentos"
                  @click="comprobarGestorDoc"><i class="fas fa-paste"></i></button>
                <!--<button type="button" class="btn btn-default" title="Mostrar envíos" @click="mostrarEnvios = !mostrarEnvios">
                  <i class="fas fa-envelope"></i></button>-->
                <button type="button" class="btn btn-default" title="Mostrar para enviar"
                  @click="mostrarenviar = !mostrarenviar"><i class="fas fa-at"></i></button>
                <button type="button" class="btn btn-default" title="Facturar en ELBA"
                  v-if="servicio?.compania?.sistema == 'ELBA_WS'" :disabled="abriendoElba" @click="abrirFacturacionElba()"><i
                    class="fas fa-file-invoice-dollar"></i></button>
                <button type="button" class="btn btn-default" title="Pdf" @click="abrirurl()"><i
                    class="fas fa-file-invoice"></i></button>
                <button v-if="factura.url_xml" type="button" class="btn btn-default" title="XML" @click="abrirurl('xml')"><i
                    class="fas fa-file-code"></i></button>
                 <!--<button type="button" class="btn btn-default" title="Imprimir"
                  @click="imprimir()"><i class="fas fa-print"></i></button>-->
              </div>
              <div class="input-group-append">
                <button v-if="!bloqueocobrada && factura.factura.cobrada != 'SI'" type="button" class="btn btn-default" title="Marcar como cobrada"
                  @click="divmarcarcobrada = !divmarcarcobrada"><i class="fas fa-money-bill-wave"></i></button>
                <button v-if="factura.factura.cobrada == 'SI'" type="button" class="btn btn-default" title="Desmarcar como cobrada"
                  @click="desmarcarcobrada()"><i class="fas fa-money-bill-wave"></i></button>  
                <!--<button v-if="abono==false && !parciales && estado" type="button" class="btn btn-default" @click="confirmar()"
                  :title="$t('general.facturaabonar')"><i class="fas fa-undo-alt"></i></button>-->
                <button v-if="abono==false && estado" type="button" class="btn btn-default"
                  @click="formabonar = !formabonar" :title="$t('general.facturaabonar')"><i class="fas fa-undo-alt"></i></button>
                <button v-if="factura.eliminable?.estado" type="button" class="btn btn-default" @click="eliminarfactura=!eliminarfactura"
                  title="Eliminar"><i class="fas fa-times"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="factura.envios_facturas.length" class="col-md-12" style="margin-top:15px;padding-right:0px;">
          <div class="card card-default w-100">
            <div class="card-body p-0">
              <table class="table table-sm mb-0">
                <thead>
                  <tr>
                    <th style="padding:5px;">Envío</th>
                    <th style="padding:5px;">Destino</th>
                    <th style="padding:5px;">Fecha/Hora</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="envio in factura.envios_facturas" :key="envio.id_envio">
                    <td style="padding:5px;">{{ envio.tipo_envio }}</td>
                    <td style="padding:5px;">{{ envio.destino_envio }}</td>
                    <td style="padding:5px;">{{ formatearFecha(envio.fecha_envio) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="mostrargestiondoc" style="margin-top: 15px;">
          <div style="height: 50px; position: relative;" class="loading-spinner"  v-if="cargandoDocumentos">
              <div style="position: absolute; inset: 0; margin: auto; height: fit-content; width: fit-content">
                  <i class="fas fa-spinner fa-spin"></i> Cargando...
              </div>            
          </div>
          <div v-else class="row">
            <div class="card card-default">
                <div class="card-header">
                    <h4 class="card-title">Gestor documentos</h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12" style="display: grid;row-gap: 15px; height: fit-content;">
                            <div class="row" style="margin-left: 0;">
                                <div style="display: grid; width: 60%;">
                                    <label for="documentos">Documento</label>
                                    <select id="documentos" class="form-control" style="width: 90%;" v-model="documentoSeleccionado">
                                        <option value="sin doc">Selecciona un documento</option>
                                        <option v-for="documento in documentosFactura" :key="documento.id_documento" :value="documento.id_documento">{{ documento.nombre }}</option>
                                    </select>
                                </div>
                                <div style="display: grid; align-items: end;">
                                    <button class="btn  btn-light border-secondary" @click="generarDocumento">Generar</button>
                                </div>
                            </div>
                            <div v-if="generadosVisible" style="display: grid; row-gap: 15px;">
                                <div v-for="(separados) in Object.entries(docsSeparados)" :key="separados[0]">
                                    <div class="card card-primary">
                                        <div class="card-header p-3">
                                            <div ><span >Documentos de {{ separados[0] }}</span></div>
                                        </div>
                                        <div class="card-body">
                                            <div v-for="doc in separados[1]" :key="doc.id_documento_generado" class="card" style="border-left:6px solid #117a8b;">
                                                <div class="card-header p-1">
                                                    <div class="row" style="gap: 15px; align-items: center; margin: 0;">
                                                            <span>{{ doc.fecha_generado }}</span>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('docx')" @click="descargar(doc.url_completa_descarga_docx)" style="color: DodgerBlue;" title="Descarga DOCX"><i class="fas fa-file-word"></i></button>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('excel')" @click="descargar(doc.url_completa_descarga_docx)" style="color: MediumSeaGreen;" title="Descarga XLSX"><i class="fas fa-file-excel"></i></button>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('pdf')" @click="descargar(doc.url_completa_descarga_pdf)" style="color: FireBrick;" title="Descarga PDF"><i class="fas fa-file-pdf"></i></button>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('pdff')" @click="descargar(doc.url_completa_descarga_pdf_firmado)" style="color: Crimson;" title="Descarga PDF Firmado"><i class="fas fa-file-signature"></i></button>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('png')" @click="descargar(doc.url_completa_descarga_png)" style="color: Teal;" title="Descarga JPG"><i class="fas fa-file-contract"></i></button>
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleForm[doc.id_documento_generado] = !visibleForm[doc.id_documento_generado]">Enviar</button>
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="confirmarEliminar(doc.id_documento_generado)">Eliminar</button>
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleEnvios[doc.id_documento_generado] = !visibleEnvios[doc.id_documento_generado]">Envíos</button>
                                                        </div>
                                                </div>
                                                <div class="card-body" v-if="docsEnviados[doc.id_documento_generado].length>0 || visibleForm[doc.id_documento_generado]">
                                                    <div v-if="visibleForm[doc.id_documento_generado]" style="width: 90%;">
                                                        <div class="form-group">
                                                                <label for="envio">Tipo envio</label>
                                                                <div>
                                                                    <select class="form-control" v-model="envioSeleccionado[doc.id_documento_generado]" id="envio">
                                                                        <option value="email">Email</option>
                                                                    </select>
                                                                </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="doc">Tipo Documento</label>
                                                            <div>
                                                                <select class="form-control" v-model="docSeleccionado[doc.id_documento_generado]" id="doc">
                                                                    <option value="pdf">PDF</option>
                                                                    <option :value="extensiones[doc.id_documento_generado]">{{ extensiones[doc.id_documento_generado] }}</option>
                                                                </select>
                                                            </div>                                                    
                                                        </div>
                                                        <div class="form-group" v-if="pap">
                                                            <label for="docPAP">Tipo documento PAP</label>
                                                            <div>
                                                                <select class="form-control" v-model="PAPSeleccionado[doc.id_documento_generado]" id="docPAP">
                                                                    <option value="">Seleccione</option>
                                                                    <option  v-for="papoption in tipo_doc_pap[doc.id_documento_generado]" :value="papoption.valor" :key="papoption">{{ papoption.texto }}</option>
                                                                </select>
                                                            </div>                                                      
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="email">Email</label>
                                                            <div style="display: grid; row-gap: 15px;">
                                                                <select class="form-control" v-model="emailSeleccionado[doc.id_documento_generado]" id="email">
                                                                    <option value="">Seleccione</option>
                                                                    <option  v-for="email in emails[doc.id_documento_generado]" :value="email.email" :key="email.email">{{ email.nombre }}</option>
                                                                </select>
                                                                <input class="form-control" v-model="emailIntroducido[doc.id_documento_generado]" type="text" placeholder="Introducir email">
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="asunto">Asunto</label>
                                                            <input class="form-control" v-model="asuntoSeleccionado[doc.id_documento_generado]" id="asunto" type="text">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="texto">Texto</label>
                                                            <div>
                                                                <textarea class="form-control" id="texto" v-model="ta[doc.id_documento_generado]"></textarea>
                                                            </div>
                                                        </div>
                                                        <div class="row" style="column-gap: 15px; margin: 0; justify-content: end;">
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="guardarForm(doc.id_documento_generado)">Enviar</button>
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleForm[doc.id_documento_generado]=false">Cerrar</button>
                                                        </div>
                                                    </div>
                                                    <hr v-if="docsEnviados[doc.id_documento_generado].length>0 && visibleForm[doc.id_documento_generado] && visibleEnvios[doc.id_documento_generado]"/>
                                                    <div  v-if="docsEnviados[doc.id_documento_generado].length>0 && visibleEnvios[doc.id_documento_generado]" style="display: grid;margin-top: 15px;">
                                                        <table class="table table-sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Fecha envío</th>
                                                                    <th>Destinatario</th>
                                                                    <th>Usuario</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody v-for="(docEnv, index) in docsEnviados[doc.id_documento_generado]" :key="docEnv.id_documento_envio">
                                                                <tr v-if="index%2==0" style="background-color: rgba(0, 0, 0, .05)">
                                                                    <td>{{ docEnv.fecha_envio }}</td>
                                                                    <td>{{ docEnv.destinatario_envio }}</td>
                                                                    <td><i class="fas fa-info-circle" style="cursor: pointer;" @click="infoExtraVisible[docEnv.id_documento_envio]=!infoExtraVisible[docEnv.id_documento_envio]"></i>{{ docEnv.usuario }}</td>
                                                                    
                                                                </tr>
                                                                <tr v-else style="background-color: white;">
                                                                    <td>{{ docEnv.fecha_envio }}</td>
                                                                    <td>{{ docEnv.destinatario_envio }}</td>
                                                                    <td><i class="fas fa-info-circle" style="cursor: pointer;" @click="infoExtraVisible[docEnv.id_documento_envio]=!infoExtraVisible[docEnv.id_documento_envio]"></i>{{ docEnv.usuario }}</td>
                                                                </tr>
                                                                <tr   v-if="infoExtraVisible[docEnv.id_documento_envio] && index%2==0" style="background-color: rgba(0, 0, 0, .05)">
                                                                    <td colspan="3">Texto enviado: {{ docEnv.texto_envio }}</td>
                                                                </tr>
                                                                <tr  v-else-if="infoExtraVisible[docEnv.id_documento_envio]" style="background-color: white;">
                                                                    <td colspan="3">Texto enviado: {{ docEnv.texto_envio }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row" style="justify-content: space-around;row-gap: 10px;" v-if="imagenes">
                                <div v-for="img in Object.entries(imagenes)" :key="img[1].id_documento">
                                    <div style="display: grid; row-gap: 10px;">
                                        <Image v-if="urlglobal != 'null.pwgs.app'" :src='img[1].url_completa_descarga' style="border: 5px solid goldenrod;" width="100" preview :alt="img[1].descripcion" />
                                        <Image v-else :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + img[1].documento + "&servicio=" +id' style="border: 5px solid goldenrod;" width="100" preview :alt="img[1].descripcion" />
                                        <input type="checkbox" v-model="activado[img[1].id_documento]">
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
          </div>
        </div>
        <div v-if="mostrarenviar">
          <div class="row">
            <div class="col-md-12">
              <br>
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <select class="form-control form-control-sm" v-model="envioSelec" id="">
                    <option v-for="[key ,envio] in Object.entries(envios)" :key="key" :value="key">{{ envio }}</option>
                  </select>
                </div>
                <input type="text" class="form-control" :disabled="envioSelec!='email' || correoseleccionado!=''"
                  v-model="correoEnvio" placeholder="Email">
                <span class="input-group-append">
                  <button type="button" class="btn btn-info"
                    @click="enviarfactura()">{{$t('general.enviar')}}</button>
                </span>
              </div>    
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <Dropdown v-if="envioSelec=='email'" v-model="correoseleccionado" :options="correos"
                optionLabel="label" optionGroupLabel="label" optionValue="value" optionGroupChildren="items"
                style="width: 100%;" placeholder="Destinatario"></Dropdown>
            </div>
          </div>
        </div>
        <div v-if="formabonar==true" style="margin-top: 15px;">          
          <div class="row">
            <div class="form-group col-md-4">
              <label for="">Serie</label>
             <!-- <input type="text" class="form-control" disabled :value="serieabono">-->
              <select v-model="serieabonoseleccionada"  class="form-control form-control-sm">
                <option v-for="serie in seriesfacturacion" :key="serie.id_serie" :value="serie.id_serie">{{serie.prefijo_abono_serie}} ({{ serie.nombre_serie }})</option>
                

              </select>
            </div>
            <div class="form-group col-md-4">
              <label for="">Número</label>
              <input type="text" class="form-control form-control-sm" disabled :value="siguienteabono">
            </div>
            <div class="form-group col-md-4">
              <label for="">Año</label>
              <input v-if="datosf.anyo_fiscal_factura == yearActual" type="text" class="form-control form-control-sm" disabled :value="datosf.anyo_fiscal_factura">
              <select v-else v-model="yearActual" :disabled="leyAntifraudeActiva"  class="form-control form-control-sm">
                <option :value="yearActual-1" >{{yearActual-1}}</option>
                <option :value="yearActual" selected>{{yearActual}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-8" style="margin-bottom: 0;">
              <label for="">Concepto</label>
              <input type="text" class="form-control form-control-sm" placeholder="Concepto" v-model="conceptoAbono">
            </div>
            <div v-if="datosf.enviadoVeriFactu == 1" class="form-group col-md-4" style="padding-top:20px;margin-bottom:0px;">
              <b><span style="color:#63E6BE;"><small>Tipo: R1-I (Rect. por diferencias)</small></span></b>
            </div>
            <div v-if="impuesto" class="form-group col-md-4" style="margin-bottom: 0;">
              <label for="">IVA</label>
              <select class="form-control form-control-sm" v-model="impuestoselec" id="">
                <option v-for="impuesto in impuestos" :key="impuesto.id" :value="impuesto.valor_iva">{{
                  impuesto.valor_iva }}</option>
              </select>
            </div>
          </div>
          <div class="input-group input-group-sm" style="margin-top: 5px; margin-bottom: 0px;">
            <input type="number" class="form-control" placeholder="Importe" v-model="importeabono" :disabled="factura.abonos.parciales==0">
            <div class="input-group-append">
              <button type="button" class="btn btn-primary" @click="abonarparcial()"
                title="Factura rectificativa">Rectificar</button>
            </div>
          </div>
        </div>
        <div v-if="divmarcarcobrada==true"
          style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; align-items: end; margin-top: 15px;">
          <div class="form-group" style="margin-bottom: 0;">
            <label for="banco" style="margin-bottom: 0;">Marcar como cobrada</label>
            <select v-model="bancoselec" class="form-control form-control-sm" id="banco">
              <option value="">Seleccione banco</option>
              <option v-for="banco in bancos" :key="banco.id_banco" :value="banco.id_banco">{{ banco.nombre_banco }}
              </option>
            </select>
          </div>
          <div class="input-group input-group-sm" style="margin-top: 20px; margin-bottom: 0px;">
            <input type="date" class="form-control" v-model="fechapago">
            <div class="input-group-append">
              <button type="button" class="btn btn-info"
                @click="divmarcarcobrada = !divmarcarcobrada;marcarcobrada()">Cobrada</button>
            </div>
          </div>
        </div>
        <div class="input-group input-group-sm" v-if="eliminarfactura==true"
          style="margin-top: 20px; margin-bottom: 0px;">
          <input type="text" class="form-control" placeholder="Motivo" v-model="motivoeliminacion">
          <div class="input-group-append">
            <button type="button" class="btn btn-danger" @click="eliminar()" title="Eliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>




    <div class="col-md-12" v-if="servicio.estado == 'Finalizado'">
      <div class="callout callout-success" :style="exportada == true?'background-color: lightgrey;':''" 
      :title="exportada == true?'Exportada en contabilidad':''">
        <div v-if="!cobrado" class="ribbon_no_cobrada ribbon-top-right"><span>{{$t('general.no cobrada')}}</span></div>
        <div v-if="cobrado" class="ribbon_cobrada ribbon-top-right"><span>{{$t('general.cobrada')}}</span></div>
        <div v-if="abono == false && cobrado" style="display: flex; gap: 20px;">          
          <h5 v-if="abono == false" style="cursor: pointer;" @click="copiarNum(factura.numero)">{{factura.error_xml?.valor == 1?'Registro':$t('general.factura')}} <strong>{{factura.numero}}</strong>
            <i style="margin-left: 5px;" v-if="exportada"  class="fas fa-file-export"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 1" class="fas fa-check-circle" title="Env&iacute;o a VeriFactu CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoVeriFactu == 2 && !factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 2 && factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO, Subsanada"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoVeriFactu == 3" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu: AceptadoConErrores"></i>
            <i style="margin-left: 5px; color: #7c7c7cff" v-if="factura.error_xml?.valor == 1" class="fas fa-exclamation-circle" :title="factura.error_xml?.texto"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoTBAI == 1" class="fas fa-check-circle" title="Env&iacute;o TBAI CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoTBAI == 2" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI INCORRECTO"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoTBAI == 3" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI: Pendiente"></i>
          </h5>
        </div>
        <div v-else-if="abono == false ">
          <h5 v-if="abono == false" style="cursor: pointer;" @click="copiarNum(factura.numero)">{{factura.error_xml?.valor == 1?'Registro':$t('general.factura')}} <strong>{{factura.numero}}</strong>
            <i style="margin-left: 5px;" v-if="exportada"  class="fas fa-file-export"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 1" class="fas fa-check-circle" title="Env&iacute;o a VeriFactu CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoVeriFactu == 2 && !factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 2 && factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO, Subsanada"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoVeriFactu == 3" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu: AceptadoConErrores"></i>
            <i style="margin-left: 5px; color: #7c7c7cff" v-if="factura.error_xml?.valor == 1" class="fas fa-exclamation-circle" :title="factura.error_xml?.texto"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoTBAI == 1" class="fas fa-check-circle" title="Env&iacute;o TBAI CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoTBAI == 2" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI INCORRECTO"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoTBAI == 3" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI: Pendiente"></i>
          </h5>
        </div>
        <div v-if="abono == true">
          <h5 style="cursor: pointer;" @click="copiarNum(factura.numero)">Rectificativa <strong>{{factura.numero}}</strong>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 1" class="fas fa-check-circle" title="Env&iacute;o a VeriFactu CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoVeriFactu == 2 && !factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoVeriFactu == 2 && factura.subsanada_verifactu" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu INCORRECTO, Subsanada"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoVeriFactu == 3" class="fas fa-exclamation-circle" title="Env&iacute;o a VeriFactu: AceptadoConErrores"></i>
            <i style="margin-left: 5px; color: #7c7c7cff" v-if="factura.error_xml?.valor == 1" class="fas fa-exclamation-circle" :title="factura.error_xml?.texto"></i>
            <i style="margin-left: 5px; color: #63E6BE" v-if="datosf.enviadoTBAI == 1" class="fas fa-check-circle" title="Env&iacute;o TBAI CORRECTO"></i>
            <i style="margin-left: 5px; color: #e66363ff" v-if="datosf.enviadoTBAI == 2" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI INCORRECTO"></i>
            <i style="margin-left: 5px; color: #ebd93aff" v-if="datosf.enviadoTBAI == 3" class="fas fa-exclamation-circle" title="Env&iacute;o TBAI: Pendiente"></i>
          </h5>
        </div>
        <div class="row" style="margin-top: 15px;">
          <div class="col-md-8" v-if="!cobrado" style="display: flex;">
            <div class="col-md-4"><input type="date" @input="actualizarFecha()" :disabled="bloquearfecha"
                v-model="datosf.fecha_hoy" class="form-control input-xs"></div>
            <div class="col-md-4" style="display:flex;justify-content:flex-end;">
              <h4><span v-if="abono == true">-</span>{{ datosf.base_imponible }}&euro;</h4>
            </div>
            <div v-if="factura.tipos_iva" class="col-md-4" style="display:flex;justify-content:flex-end;">
              <h4>{{ factura.tipos_iva[0] }}%</h4>
            </div>
          </div>
          <div class="col-md-8" style="display: flex;" v-else>
            <div class="col-md-2"><input type="date" @input="actualizarFecha()" :disabled="bloquearfecha"
                v-model="datosf.fecha_hoy" class="form-control input-xs"></div>
            <div class="col-md-3" style="display:flex;justify-content:flex-end;">
              <h4><span v-if="abono == true">-</span>{{ datosf.base_imponible }}&euro;</h4>
            </div>
            <div v-if="factura.tipos_iva" class="col-md-3" style="display:flex;justify-content:flex-end;">
              <h4>{{ factura.tipos_iva[0] }}%</h4>
            </div>
            <div title="Fecha de cobro" style="display:flex;justify-content:flex-end; gap: 10px;align-items: center;" class="col-md-4">
              <label for="">Fecha de cobro:</label>
              <h4>
                {{ fechapago }}
              </h4>
            </div>
          </div>
          <div class="col-md-4" style="display:flex;justify-content:flex-end;">
            <div class="input-group" style="width: auto;">
              <div class="input-group-prepend">
                <button v-if="factura.enviada_factura == 'NO'" type="button" class="btn btn-default" title="Enviar a axa"
                  @click="enviarAxa"><i class="fas fa-font"></i></button>
                <button v-if="documentosFactura && documentosFactura.length > 0" type="button" class="btn btn-default" title="Mostrar gestor de documentos"
                  @click="comprobarGestorDoc"><i class="fas fa-paste"></i></button>
                <!--<button type="button" class="btn btn-default" title="Mostrar envíos" @click="mostrarEnvios = !mostrarEnvios">
                  <i class="fas fa-envelope"></i></button>-->
                <button type="button" class="btn btn-default" title="Mostrar para enviar"
                  @click="mostrarenviar = !mostrarenviar"><i class="fas fa-at"></i></button>
                <button type="button" class="btn btn-default" title="Facturar en ELBA"
                  v-if="servicio?.compania?.sistema == 'ELBA_WS'" :disabled="abriendoElba" @click="abrirFacturacionElba()"><i
                    class="fas fa-file-invoice-dollar"></i></button>
                <button type="button" class="btn btn-default" title="Pdf" @click="abrirurl()"><i
                    class="fas fa-file-invoice"></i></button>
                <button v-if="factura.url_xml" type="button" class="btn btn-default" title="XML" @click="abrirurl('xml')"><i
                    class="fas fa-file-code"></i></button>
              </div>
              <div class="input-group-append">
                <button v-if="!bloqueocobrada && factura.factura.cobrada != 'SI'" type="button" class="btn btn-default" title="Marcar como cobrada"
                  @click="divmarcarcobrada = !divmarcarcobrada"><i class="fas fa-money-bill-wave"></i></button>
                <button v-if="factura.factura.cobrada == 'SI'" type="button" class="btn btn-default" title="Desmarcar como cobrada"
                  @click="desmarcarcobrada()"><i class="fas fa-money-bill-wave"></i></button>  
                <!--<button v-if="abono == false && !parciales && estado" type="button" class="btn btn-default" @click="confirmar()"
                  :title="$t('general.facturaabonar')"><i class="fas fa-undo-alt"></i></button>-->
                <button v-if="abono == false && estado" type="button" class="btn btn-default"
                  @click="formabonar = !formabonar" :title="$t('general.facturaabonar')"><i class="fas fa-undo-alt"></i></button>
                <button v-if="factura.eliminable?.estado" type="button" class="btn btn-default" @click="eliminarfactura = !eliminarfactura"
                  title="Eliminar"><i class="fas fa-times"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="factura.envios_facturas.length" class="col-md-12" style="margin-top:15px;padding-right:0px;">
          <div class="card card-default w-100">
            <div class="card-body p-0">
              <table class="table table-sm mb-0">
                <thead>
                  <tr>
                    <th style="padding:5px;">Envío</th>
                    <th style="padding:5px;">Destino</th>
                    <th style="padding:5px;">Fecha/Hora</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="envio in factura.envios_facturas" :key="envio.id_envio">
                    <td style="padding:5px;">{{ envio.tipo_envio }}</td>
                    <td style="padding:5px;">{{ envio.destino_envio }}</td>
                    <td style="padding:5px;">{{ formatearFecha(envio.fecha_envio) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="mostrargestiondoc" style="margin-top: 15px;">
          <div style="height: 50px; position: relative;" class="loading-spinner"  v-if="cargandoDocumentos">
              <div style="position: absolute; inset: 0; margin: auto; height: fit-content; width: fit-content">
                  <i class="fas fa-spinner fa-spin"></i> Cargando...
              </div>            
          </div>
          <div v-else class="row">
            <div class="card card-default">
                <div class="card-header">
                    <h4 class="card-title">Gestor documentos</h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12" style="display: grid;row-gap: 15px; height: fit-content;">
                            <div class="row" style="margin-left: 0;">
                                <div style="display: grid; width: 60%;">
                                    <label for="documentos">Documento</label>
                                    <select id="documentos" class="form-control" style="width: 90%;" v-model="documentoSeleccionado">
                                        <option value="sin doc">Selecciona un documento</option>
                                        <option v-for="documento in documentosFactura" :key="documento.id_documento" :value="documento.id_documento">{{ documento.nombre }}</option>
                                    </select>
                                </div>
                                <div style="display: grid; align-items: end;">
                                    <button class="btn  btn-light border-secondary" @click="generarDocumento">Generar</button>
                                </div>
                            </div>
                            <div v-if="generadosVisible" style="display: grid; row-gap: 15px;">
                                <div v-for="(separados) in Object.entries(docsSeparados)" :key="separados[0]">
                                    <div class="card card-primary">
                                        <div class="card-header p-3">
                                            <div ><span >Documentos de {{ separados[0] }}</span></div>
                                        </div>
                                        <div class="card-body">
                                            <div v-for="doc in separados[1]" :key="doc.id_documento_generado" class="card" style="border-left:6px solid #117a8b;">
                                                <div class="card-header p-1">
                                                    <div class="row" style="gap: 15px; align-items: center; margin: 0;">
                                                            <span>{{ doc.fecha_generado }}</span>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('docx')" @click="descargar(doc.url_completa_descarga_docx)" style="color: DodgerBlue;" title="Descarga DOCX"><i class="fas fa-file-word"></i></button>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('excel')" @click="descargar(doc.url_completa_descarga_docx)" style="color: MediumSeaGreen;" title="Descarga XLSX"><i class="fas fa-file-excel"></i></button>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('pdf')" @click="descargar(doc.url_completa_descarga_pdf)" style="color: FireBrick;" title="Descarga PDF"><i class="fas fa-file-pdf"></i></button>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('pdff')" @click="descargar(doc.url_completa_descarga_pdf_firmado)" style="color: Crimson;" title="Descarga PDF Firmado"><i class="fas fa-file-signature"></i></button>
                                                            <button class="btn btn-light" v-if=" botones[doc.id_documento_generado].includes('png')" @click="descargar(doc.url_completa_descarga_png)" style="color: Teal;" title="Descarga JPG"><i class="fas fa-file-contract"></i></button>
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleForm[doc.id_documento_generado] = !visibleForm[doc.id_documento_generado]">Enviar</button>
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="confirmarEliminar(doc.id_documento_generado)">Eliminar</button>
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleEnvios[doc.id_documento_generado] = !visibleEnvios[doc.id_documento_generado]">Envíos</button>
                                                        </div>
                                                </div>
                                                <div class="card-body" v-if="docsEnviados[doc.id_documento_generado].length>0 || visibleForm[doc.id_documento_generado]">
                                                    <div v-if="visibleForm[doc.id_documento_generado]" style="width: 90%;">
                                                        <div class="form-group">
                                                                <label for="envio">Tipo envio</label>
                                                                <div>
                                                                    <select class="form-control" v-model="envioSeleccionado[doc.id_documento_generado]" id="envio">
                                                                        <option value="email">Email</option>
                                                                        <option value="pap" v-if="pap">PAP</option>
                                                                    </select>
                                                                </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="doc">Tipo Documento</label>
                                                            <div>
                                                                <select class="form-control" v-model="docSeleccionado[doc.id_documento_generado]" id="doc">
                                                                    <option value="pdf">PDF</option>
                                                                    <option :value="extensiones[doc.id_documento_generado]">{{ extensiones[doc.id_documento_generado] }}</option>
                                                                </select>
                                                            </div>                                                    
                                                        </div>
                                                        <div class="form-group" v-if="pap">
                                                            <label for="docPAP">Tipo documento PAP</label>
                                                            <div>
                                                                <select class="form-control" v-model="PAPSeleccionado[doc.id_documento_generado]" id="docPAP">
                                                                    <option value="">Seleccione</option>
                                                                    <option  v-for="papoption in tipo_doc_pap[doc.id_documento_generado]" :value="papoption.valor" :key="papoption">{{ papoption.texto }}</option>
                                                                </select>
                                                            </div>                                                      
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="email">Email</label>
                                                            <div style="display: grid; row-gap: 15px;">
                                                                <select class="form-control" v-model="emailSeleccionado[doc.id_documento_generado]" id="email">
                                                                    <option value="">Seleccione</option>
                                                                    <option  v-for="email in emails[doc.id_documento_generado]" :value="email.email" :key="email.email">{{ email.nombre }}</option>
                                                                </select>
                                                                <input class="form-control" v-model="emailIntroducido[doc.id_documento_generado]" type="text" placeholder="Introducir email">
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="asunto">Asunto</label>
                                                            <input class="form-control" v-model="asuntoSeleccionado[doc.id_documento_generado]" id="asunto" type="text">
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="texto">Texto</label>
                                                            <div>
                                                                <textarea class="form-control" id="texto" v-model="ta[doc.id_documento_generado]"></textarea>
                                                            </div>
                                                        </div>
                                                        <div class="row" style="column-gap: 15px; margin: 0; justify-content: end;">
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="guardarForm(doc.id_documento_generado)">Enviar</button>
                                                            <button class="btn btn-sm btn-light" style="border: 1px solid grey;" @click="visibleForm[doc.id_documento_generado]=false">Cerrar</button>
                                                        </div>
                                                    </div>
                                                    <hr v-if="docsEnviados[doc.id_documento_generado].length>0 && visibleForm[doc.id_documento_generado] && visibleEnvios[doc.id_documento_generado]"/>
                                                    <div  v-if="docsEnviados[doc.id_documento_generado].length>0 && visibleEnvios[doc.id_documento_generado]" style="display: grid;margin-top: 15px;">
                                                        <table class="table table-sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Fecha envío</th>
                                                                    <th>Destinatario</th>
                                                                    <th>Usuario</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody v-for="(docEnv, index) in docsEnviados[doc.id_documento_generado]" :key="docEnv.id_documento_envio">
                                                                <tr v-if="index%2==0" style="background-color: rgba(0, 0, 0, .05)">
                                                                    <td>{{ docEnv.fecha_envio }}</td>
                                                                    <td>{{ docEnv.destinatario_envio }}</td>
                                                                    <td><i class="fas fa-info-circle" style="cursor: pointer;" @click="infoExtraVisible[docEnv.id_documento_envio]=!infoExtraVisible[docEnv.id_documento_envio]"></i>{{ docEnv.usuario }}</td>
                                                                    
                                                                </tr>
                                                                <tr v-else style="background-color: white;">
                                                                    <td>{{ docEnv.fecha_envio }}</td>
                                                                    <td>{{ docEnv.destinatario_envio }}</td>
                                                                    <td><i class="fas fa-info-circle" style="cursor: pointer;" @click="infoExtraVisible[docEnv.id_documento_envio]=!infoExtraVisible[docEnv.id_documento_envio]"></i>{{ docEnv.usuario }}</td>
                                                                </tr>
                                                                <tr   v-if="infoExtraVisible[docEnv.id_documento_envio] && index%2==0" style="background-color: rgba(0, 0, 0, .05)">
                                                                    <td colspan="3">Texto enviado: {{ docEnv.texto_envio }}</td>
                                                                </tr>
                                                                <tr  v-else-if="infoExtraVisible[docEnv.id_documento_envio]" style="background-color: white;">
                                                                    <td colspan="3">Texto enviado: {{ docEnv.texto_envio }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row" style="justify-content: space-around;row-gap: 10px;" v-if="imagenes">
                                <div v-for="img in Object.entries(imagenes)" :key="img[1].id_documento">
                                    <div style="display: grid; row-gap: 10px;">
                                        <Image v-if="urlglobal != 'null.pwgs.app'" :src='img[1].url_completa_descarga' style="border: 5px solid goldenrod;" width="100" preview :alt="img[1].descripcion" />
                                        <Image v-else :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + img[1].documento + "&servicio=" +id' style="border: 5px solid goldenrod;" width="100" preview :alt="img[1].descripcion" />
                                        <input type="checkbox" v-model="activado[img[1].id_documento]">
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                </div>
            </div>
          </div>
        </div>
        <div v-if="mostrarenviar">
          <div class="row">
            <div class="col-md-12">
              <br>
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <select class="form-control form-control-sm" v-model="envioSelec" id="">
                    <option v-for="[key, envio] in Object.entries(envios)" :key="key" :value="key">{{ envio }}</option>
                  </select>
                </div>
                <input type="text" class="form-control" :disabled="envioSelec != 'email' || correoseleccionado != ''"
                  v-model="correoEnvio" placeholder="Email">
                <span class="input-group-append">
                  <button type="button" class="btn btn-info" @click="enviarfactura()">{{ $t('general.enviar')
                    }}</button>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <Dropdown :disabled="envioSelec != 'email'" v-model="correoseleccionado" :options="correos"
                optionLabel="label" optionGroupLabel="label" optionValue="value" optionGroupChildren="items"
                style="width: 100%;" placeholder="Destinatario"></Dropdown>
            </div>
          </div>
        </div>
        <div v-if="formabonar == true" style="margin-top: 15px;">          
          <div class="row">
            <div class="form-group col-md-4">
              <label for="">Serie</label>
            <!--  <input type="text" class="form-control" disabled :value="serieabono">-->
              <select v-model="serieabonoseleccionada"  class="form-control form-control-sm">
                <option v-for="serie in seriesfacturacion" :key="serie.id_serie" :value="serie.id_serie">{{serie.prefijo_abono_serie}} ({{ serie.nombre_serie }})</option>
              </select>
            </div>
            <div class="form-group col-md-4">
              <label for="">Número</label>
              <input type="text" class="form-control form-control-sm" disabled :value="siguienteabono">
            </div>
            <div class="form-group col-md-4">
              <label for="">Año</label>
              <input v-if="datosf.anyo_fiscal_factura == yearActual" type="text" class="form-control form-control-sm" disabled :value="datosf.anyo_fiscal_factura">
              <select v-else v-model="yearActual" :disabled="leyAntifraudeActiva"  class="form-control form-control-sm">
                <option :value="yearActual-1" >{{yearActual-1}}</option>
                <option :value="yearActual" selected>{{yearActual}}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-8" style="margin-bottom: 0;">
              <label for="">Concepto</label>
              <input type="text" class="form-control form-control-sm" placeholder="Concepto" v-model="conceptoAbono">
            </div>
            <div v-if="datosf.enviadoVeriFactu == 1" class="form-group col-md-4" style="padding-top:35px;margin-bottom:0px;">
              <b><span style="color:#63E6BE;">Tipo: R1-I (Rectificativa por diferencias)</span></b>
            </div>
            <div v-if="impuesto" class="form-group col-md-4" style="margin-bottom: 0;">
              <label for="">IVA</label>
              <select class="form-control form-control-sm" v-model="impuestoselec" id="">
                <option v-for="impuesto in impuestos" :key="impuesto.id" :value="impuesto.valor_iva">{{
                  impuesto.valor_iva }}</option>
              </select>
            </div>
          </div>
          <div class="input-group input-group-sm" style="margin-top: 5px; margin-bottom: 0px;">
            <input type="number" class="form-control" placeholder="Importe" v-model="importeabono" :disabled="factura.abonos.parciales==0">
            <div class="input-group-append">
              <button type="button" class="btn btn-primary" @click="abonarparcial()"
                title="Factura rectificativa">Rectificar</button>
            </div>
          </div>
        </div>
        <div v-if="divmarcarcobrada == true"
          style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; align-items: end; margin-top: 15px;">
          <div class="form-group" style="margin-bottom: 0;">
            <label for="banco" style="margin-bottom: 0;">Marcar como cobrada</label>
            <select v-model="bancoselec" class="form-control form-control-sm" id="banco">
              <option value="">Seleccione banco</option>
              <option v-for="banco in bancos" :key="banco.id_banco" :value="banco.id_banco">{{ banco.nombre_banco }}
              </option>
            </select>
          </div>
          <div class="input-group input-group-sm" style="margin-top: 20px; margin-bottom: 0px;">
            <input type="date" class="form-control" v-model="fechapago">
            <div class="input-group-append">
              <button type="button" class="btn btn-info"
                @click="divmarcarcobrada = !divmarcarcobrada; marcarcobrada()">Cobrada</button>
            </div>
          </div>
        </div>
        <div class="input-group input-group-sm" v-if="eliminarfactura == true"
          style="margin-top: 20px; margin-bottom: 0px;">
          <input type="text" class="form-control" placeholder="Motivo" v-model="motivoeliminacion">
          <div class="input-group-append">
            <button type="button" class="btn btn-danger" @click="eliminar()" title="Eliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>




  </div>
</template>

<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';

import $ from 'jquery';
export default {
  props: ['id', 'servicio', 'factura','togglecargar','servicioext'],
    components:{
      Dropdown,
    },
    data() {
        return {
          serieabono: '',
          seriesfacturacion:'',
          serieabonoseleccionada:'',
          yearActual:'',
          siguienteabono: '',
          estado:false,
          no_factura: localStorage.getItem('no_factura'),
          mostrarEnvios:false,
          visibleEnvios:[],
          infoExtraVisible:[],
          visibleForm:[],
          PAPSeleccionado:[],
          envioSeleccionado:[],
          docSeleccionado:[],
          docsSeparados:[],
          generadosVisible: false,
          docsEnviados:[],
          ta:[],
          asuntoSeleccionado:[],
          codigo:'',
          tipo_doc_pap:[],
          visible: false,
          urlglobal: "",
          documentosServicio: [],
          docsGenerados:[],
          botones:[[]],
          pap:false,
          extensiones:[],
          emailSeleccionado:[],
          emailIntroducido:[],
          mostrargestiondoc:false,
          mostrarenviar:false,
          importeabono:'',
          conceptoAbono:'',
          mostrarModulo: false,
          datosf: '',
          datosurl: "",
          url: "",
          emails: [],
          motivo: "Prueba",
          motivoeliminacion:"",
          destino: "Destino",
          eliminarfactura:false,
          cobrado:false,
          divmarcarcobrada:false,
          bancos:[],
          bancoselec: '',
          fechapago:'',
          bloqueocobrada: false,
          abono:null,
          parciales: false,
          formabonar:false,
          impuestos: [],
          impuestoselec:'',
          envios:[],
          correos:[],
          envioSelec:'email',
          correoseleccionado:'',
          correoEnvio:'',
          bloquearfecha:false,
          exportada:false,
          documentosFactura:null,
          cargandoDocumentos:true,
          documentoSeleccionado: "sin doc",
          url_xml: '',
          leyAntifraudeActiva:false,
          idserieseleccionada:'',
          abriendoElba: false,
        }
    },
    methods: {
      async enviarAxa(){
        const api = new PwgsApi();
        try {
          await api.post('servicios/' + this.$props.id + '/facturar-axa', {id_factura: this.$props.factura.factura.id_factura});
          this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Facturación realizada', life: 2000 });
          this.$parent.cargardatosFactura();
        }catch (e) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
        }
      },
      copiarNum(codigo) {
           navigator.clipboard.writeText(codigo);
          this.$toast.add({ severity: 'success', summary: 'Copiado', detail: 'Código copiado', life: 2000 });
        },
      descargar(link){
            //let urlglobal = localStorage.getItem('direccion');
            window.open(link, "width=800, height=600");
        },  
      async cargarSeriesFacturacion(){
        // companias/id_compania/lineas-facturacion
        const api = new PwgsApi();
        let aux = await api.get('companias/'+this.$props.servicio.compania.id+'/lineas-facturacion');
        this.seriesfacturacion = aux.datos;
        this.serieabonoseleccionada = this.$props.factura?.abonos?.id_serie;
      },
      async guardarForm(idDoc){
          if(this.emailIntroducido[idDoc]==''){
              alert('Introduce un email');
              return;
          }
          if(this.ta[idDoc]==''){
              alert('Introduce un texto');
              return;
          }
          const api = new PwgsApi();
          var body = {'tipo_envio': this.envioSeleccionado[idDoc], 'formato':this.docSeleccionado[idDoc],
            'email':this.emailIntroducido[idDoc],'texto':this.ta[idDoc],'asunto':this.asuntoSeleccionado[idDoc]};
          if(this.pap){
              body.pap = this.PAPSeleccionado[idDoc];
          }
          await api.put('servicios/'+this.id+'/enviar-gestion-doc/'+idDoc,body);
          this.generadosVisible = false;
          this.cargarnuevos();
      },
      confirmarEliminar(idDoc){
        this.$confirm.require({
            message: '¿Seguro que quieres eliminar el documento?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            rejectClass: 'p-button-secondary p-button-outlined',
            rejectLabel: 'Cancelar',
            acceptLabel: 'Aceptar',
            accept: () => {
            this.eliminarDoc(idDoc)
            },
            reject: () => {
                return;
            }
        });          
      },
      async eliminarDoc(idDoc){
          const api = new PwgsApi();
          await api.delete('/servicios/'+this.id+'/gestion-doc/'+idDoc);
          this.generadosVisible = false;
          this.generadosVisible = false;
          this.cargarnuevos();
      },
      comprobarCodigo(){
          if(this.servicio){
              this.codigo='Exp.'+this.servicio.codigo_original;
              if(this.servicio.compania.sistema=="P.A.P"){
                  this.pap=true;
              }
              this.obtenerGenerados();
          }
      }, 
      obtenerGenerados(){
          try{
              this.docsGenerados = [];
              this.docsSeparados = [];
              this.docsEnviados = [];
              this.docsGenerados = this.factura.gestiondoc_generados;
              for(let docs of this.docsGenerados){
                  this.docsEnviados[docs.id_documento_generado] = docs.envios;
                  var nombre = docs.datos_documento.nombre;
                  if(this.docsSeparados[nombre]){
                      this.docsSeparados[nombre].push(docs);
                  }else{
                      this.docsSeparados[nombre]=[docs];
                  }
                  if (!this.botones[docs.id_documento_generado]) {
                      this.botones[docs.id_documento_generado] = [];
                  }
                  this.visibleForm[docs.id_documento_generado] = false;
                  this.visibleEnvios[docs.id_documento_generado] = false;
                  this.extensiones[docs.id_documento_generado] = docs.datos_documento.extension;
                  this.tipo_doc_pap[docs.id_documento_generado] = docs.tipo_doc_pap;
                  this.envioSeleccionado[docs.id_documento_generado]='email';
                  this.docSeleccionado[docs.id_documento_generado]='pdf';
                  this.PAPSeleccionado[docs.id_documento_generado]='';
                  this.emailSeleccionado[docs.id_documento_generado]='';
                  this.emails[docs.id_documento_generado]=docs.emails;
                  this.emailIntroducido[docs.id_documento_generado]='';
                  this.ta[docs.id_documento_generado]='';
                  this.asuntoSeleccionado[docs.id_documento_generado]=this.codigo;
                  if(docs.ruta_generado){
                      const ruta = docs.ruta_generado.toLowerCase();
                      if(ruta.includes('.docx')){
                          this.botones[docs.id_documento_generado].push('docx')
                      }else{
                          this.botones[docs.id_documento_generado].push('excel')
                      }
                  }
                  if(docs.ruta_pdf_generado){
                      this.botones[docs.id_documento_generado].push('pdf')
                  }
                  if(docs.ruta_png_generado){
                      this.botones[docs.id_documento_generado].push('png')
                  }
                  if(docs.ruta_pdf_generado_firmado){
                      this.botones[docs.id_documento_generado].push('pdff')
                  }
              }
              this.generadosVisible = true;
          }catch(e){
              console.log('sin docs generados',e)
          }
      },
      async generarDocumento(){
          if(this.documentoSeleccionado != 'sin doc'){
            const api = new PwgsApi();
            try{
                var body = {'seccion': 'facturas', 'id_seccion':this.$props.factura.factura.id_factura, 'id_documento':this.documentoSeleccionado};
                await api.post('/servicios/'+this.id+'/generar-gestion-doc', body);
                this.generadosVisible = false;
                this.$toast.add({severity: 'success', summary:'Generado', detail: 'Documento generado', life: 2000});
                this.cargarnuevos();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
          }else{
              alert('Selecciona un documento');
          }
      },
      async desmarcarcobrada(){
        if (confirm('¿Desea desmarcar el cobro de la factura?')) {
            const api = new PwgsApi();
        let subidadatos = {cobrada: ''};
          try {
            await api.put('facturas/' + this.$props.factura.factura.id_factura + '/modificar-factura', subidadatos);
            this.$parent.cargardatosFactura();
          }
          catch (error) {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
         }
        }
      },
      async comprobarLeyantifraude(){
        const api = new PwgsApi();
      const leyAnti = await api.get('parametros-pwgs/actualizacion_ley_antifraude');
        if(leyAnti.actualizacion_ley_antifraude == 1){
          this.leyAntifraudeActiva = true;
        }
        else{
          this.leyAntifraudeActiva = false;
        }
      },
      async cargarnuevos(){
          const api = new PwgsApi();
          try{
              this.generadosVisible = false;
              var datos = await api.get('/facturas/'+this.id+'/servicio');
              var fac = {};
              for(let fact of datos){
                if(fact.factura.id_factura==this.$props.factura.factura.id_factura){
                  fac = fact;
                }
              }
              var docus = fac.gestiondoc_generados;
              this.docsGenerados = [];
              this.docsSeparados = [];
              this.docsEnviados = [];
              this.docsGenerados = docus;
              for(let docs of this.docsGenerados){
                  this.docsEnviados[docs.id_documento_generado] = docs.envios;
                  var nombre = docs.datos_documento.nombre;
                  if(this.docsSeparados[nombre]){
                      this.docsSeparados[nombre].push(docs);
                  }else{
                      this.docsSeparados[nombre]=[docs];
                  }
                  if (!this.botones[docs.id_documento_generado]) {
                      this.botones[docs.id_documento_generado] = [];
                  }
                  
                  this.visibleForm[docs.id_documento_generado] = false;
                  this.visibleEnvios[docs.id_documento_generado] = false;
                  this.extensiones[docs.id_documento_generado] = docs.datos_documento.extension;
                  this.tipo_doc_pap[docs.id_documento_generado] = docs.tipo_doc_pap;
                  this.envioSeleccionado[docs.id_documento_generado]='email';
                  this.docSeleccionado[docs.id_documento_generado]='pdf';
                  this.PAPSeleccionado[docs.id_documento_generado]='';
                  this.emailSeleccionado[docs.id_documento_generado]='';
                  this.emails[docs.id_documento_generado]=docs.emails;
                  this.emailIntroducido[docs.id_documento_generado]='';
                  this.ta[docs.id_documento_generado]='';
                  this.asuntoSeleccionado[docs.id_documento_generado]=this.codigo;
                  
                  if(docs.ruta_generado){
                      const ruta = docs.ruta_generado.toLowerCase();
                      if(ruta.includes('.docx')){
                          this.botones[docs.id_documento_generado].push('docx')
                      }else{
                          this.botones[docs.id_documento_generado].push('excel')
                      }
                  }
                  if(docs.ruta_pdf_generado){
                      this.botones[docs.id_documento_generado].push('pdf')
                  }
                  if(docs.ruta_png_generado){
                      this.botones[docs.id_documento_generado].push('png')
                  }
                  if(docs.ruta_pdf_generado_firmado){
                      this.botones[docs.id_documento_generado].push('pdff')
                  }
              }
              this.generadosVisible = true;
          }catch(e){
              console.error('No hay docus. ', e);
          }
      },  
      comprobarGestorDoc(){
        if(this.mostrargestiondoc == true){
          this.mostrargestiondoc = false;
        }else{
          this.mostrargestiondoc = true;          
        }
      },
      async obteneDocumentosFactura(){
          this.cargandoDocumentos = true;
          const api = new PwgsApi();
          const resp = await api.get('/servicios/'+this.id+'/gestion-doc?tipo=facturas');
          this.documentosFactura = resp.gestiondoc.facturas;
          this.cargandoDocumentos = false;
      },  
      async abonarparcial(){
        try{
          const api = new PwgsApi();
          await api.post('facturas/'+this.$props.factura.factura.id_factura+'/abonar', {importe: this.importeabono, concepto: this.conceptoAbono, iva: this.impuestoselec, id_serie: this.serieabonoseleccionada});
          this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
          this.$parent.cargardatosFactura();
        }catch(e){
          this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
        }
      },
      confirmar(){
        var tipo_rectificativa = '';
        if(this.$props.factura.url_xml!==''){
           tipo_rectificativa = '\nTipo: R1-I (Rectificativa por diferencias)';
        }
        this.$confirm.require({
            message: '¿Seguro que quieres rectificar la factura?'+tipo_rectificativa,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            rejectClass: 'p-button-secondary p-button-outlined',
            rejectLabel: 'Cancelar',
            acceptLabel: 'Aceptar',
            accept: () => {
              this.pagarfactura()
            },
            reject: () => {
                return;
            }
        });
      },
      async marcarcobrada(){
        if(this.bancoselec == ''){
          alert('Debe seleccionar un banco');
          return;
        }
        const api = new PwgsApi();
        await api.put('facturas/'+this.$props.factura.factura.id_factura+'/banco', {banco: this.bancoselec, fecha: this.fechaesp(this.fechapago)});
        this.$parent.cargardatosFactura();
      },
      fechaing(fecha) {
          const [dia, mes, año] = fecha.split("/");
          return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
      },
      fechaesp(fecha) {
          const [año, mes, dia] = fecha.split("-");
          return `${dia}/${mes}/${año}`;
      },
      async cargardatos() {
        const api = new PwgsApi();
        const resp = await api.get('/bancos');
        this.bancos = resp.datos;
        const ress = await api.get('impuestos');
        this.impuestos = ress.datos;
        this.envios = this.factura.envios_disponibles;
        for(let envio of Object.entries(this.envios)){
         if(envio[0] == 'WS'){
          this.envioSelec = envio[0];
         }
         if(envio[1] == 'P.A.P.'){
           this.mostrarenviar = true;
         }
        }
        var destinatarios = this.factura.correos;
        var correos = [];
        /*var correogeneral = {
          label: 'Seleccione destinatario',
          items: [
            {label:'Seleccione destinatario', value: ''}
          ]
        };
        correos.push(correogeneral);*/
        for(let [key, value] of Object.entries(destinatarios)){
          var nuevo = {};
          if(key == 'Compañía' || key == 'Otros Compañía'){
            nuevo ={
              label:key,
              items:[]
            };
            for(let [nombre, correo] of Object.entries(value)){
              nombre;
              nuevo.items.push({label:'('+correo+')', value:correo});
            }
            correos.push(nuevo);
          }else{
            nuevo ={
              label:key,
              items:[]
            };
            for(let [nombre, correo] of Object.entries(value)){
              nuevo.items.push({label:nombre+'('+correo+')', value:correo});
            }
            correos.push(nuevo);
          }
        }
        this.correos = correos;
        if(this.factura.factura.trabajos[0]){
          var ivadefecto = this.factura.factura.trabajos[0].iva;
          var impuestoencontrado =this.impuestos.find(i => i.valor_iva == ivadefecto);
          if(impuestoencontrado){
            this.impuestoselec = impuestoencontrado.valor_iva;
          }
        }
        if(this.factura.factura.cobrada == 'SI')this.cobrado = true;
        if(this.factura.abonos && this.factura.abonos.parciales && (this.factura.abonos.parciales == '1' || this.factura.abonos.parciales == true))this.parciales = true;
        if(this.factura.abonos && this.factura.abonos.estado && (this.factura.abonos.estado == '1' || this.factura.abonos.estado == true))this.estado = true;
        if(this.factura.bloqueos.cobrada == 1){
          this.bloqueocobrada = true;
        }
        if(this.factura.bloqueos.fecha_factura == '1'){
          this.bloquearfecha = true;
        }
        if(this.factura.factura.exportada_contabilidad == '1'){
          this.exportada = true;
        }
        this.datosf = this.$props.factura.factura;
        this.datosf.tipo == 'abono'?this.abono=true:this.abono=false;
        if(this.cobrado){
          this.fechapago = this.fechaesp(this.datosf.fecha_cobro);
        }else{
          this.fechapago = this.fechaing(new Date().toLocaleString().substring(0, 9));
        }
       
        this.datosf.fecha_hoy = this.fechaing(this.datosf.fecha_hoy);
        this.url = this.$props.factura.url_completa_factura_pdf;
        this.datosurl = this.url;
        this.importeabono = this.datosf.base_imponible;
        this.siguienteabono = this.$props.factura.abonos.siguiente_numero;
        this.serieabono = '('+this.$props.factura.abonos.prefijo+')'+this.$props.factura.abonos.serie;
        this.yearActual = new Date().getFullYear();
        this.url_xml = this.factura.url_xml;
      },
      async actualizarFecha() {
        if (confirm('¿Desea actualizar la fecha?')) {
          const api = new PwgsApi();
          try { 
            await api.put('facturas/'+this.$props.factura.factura.id_factura+'/modificar-factura', {fecha_factura: this.datosf.fecha_hoy});
            this.$toast.add({ severity: 'success', summary: 'Cambiada', detail: 'Fecha cambiada correctamente', life: 2000 });
          }
          catch (error) {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
          }
        }
      },
      abrirurl(formato) {
        if(formato=='xml'){
          window.open(this.url_xml,'_blank', "width=800, height=600");
        }else{
          window.open(this.datosurl,'_blank', "width=800, height=600");
        }
      },
      imprimir() {
        const pdfWindow = window.open(this.datosurl);
        setTimeout(() => {
          pdfWindow.focus();
          //pdfWindow.print();
          //pdfWindow.close();
        pdfWindow.dispatchEvent(
        new KeyboardEvent("keydown", {
            key: "p",
            keyCode: 80, // example values.
            code: "KeyE", // put everything you need in this object.
            which: 80,
            shiftKey: false, // you don't need to include values
            ctrlKey: true,  // if you aren't going to use them.
            metaKey: false   // these are here for example's sake.
          })
        );
        }, 3000);
        $(pdfWindow).on('load', function () { 
        });
        //pdfWindow.close();
      },
      async enviarfactura() {
        //PUT  modulos/pwgsapi/index.php/facturas/:id_factura/enviar-factura
        try {
          var subidadatos = {};
          if(this.envioSelec == 'email'){
            subidadatos = { tipo: this.envioSelec, emails: [this.correoEnvio] };
            /*if(this.factura.parametros_sistema_compania.length > 0){
              for(let clave of this.factura.parametros_sistema_compania){
                if(clave.tipo == 'hidden'){
                  clave=clave.valor;
                }
              }
            }
            subidadatos.clave_certificado = clave;*/
          }else{
            subidadatos = { tipo: this.envioSelec};
            /*if(this.factura.parametros_sistema_compania.length > 0){
              for(let clave of this.factura.parametros_sistema_compania){
                if(clave.tipo == 'hidden'){
                  clave=clave.valor;
                }
              }
            }
            subidadatos.clave_certificado = clave;*/
          }
          const api = new PwgsApi();
          const resp = await api.put('facturas/' + this.$props.factura.factura.id_factura + '/enviar-factura', subidadatos);
          if(resp && resp !== 'OK'){
            this.$toast.add({ severity: 'warn', summary: 'Pendiente de validación', detail: resp, life: 6000 });
          }else if(this.factura.error_xml?.valor == 1){
            this.$toast.add({ severity: 'success', summary: 'Enviada', detail: 'Registro enviado correctamente', life: 2000 });
          }else{
            this.$toast.add({ severity: 'success', summary: 'Enviada', detail: 'Factura enviada correctamente', life: 2000 });
          }
          this.$parent.cargardatosFactura();
        }
        catch (error) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
        }
      },
      async siguientefactura(id) {
            //POST  modulos/pwgsapi/index.php/facturas/:id_servicio/siguiente-numero
            const api = new PwgsApi();
            let datos;
            let subidadatos = {year:this.yearActual};
            datos = await api.post('facturas/' + this.$props.id + '/siguiente-numero', subidadatos);
            this.siguienteabono = datos[id].numero_abono;
      },
      async pagarfactura() {
        const api = new PwgsApi();
        try{
          await api.post('facturas/'+this.$props.factura.factura.id_factura+'/abonar');
          this.$toast.add({ severity:'success', summary: 'Abonado', detail: 'Factura abonada', life: 2000 });
          this.$parent.cargardatosFactura();
        }catch(e){
          this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
        }
      },
      async eliminar() {
        //DELETE  modulos/pwgsapi/index.php/facturas/:id_factura/eliminar-factura
        if(this.motivoeliminacion == ''){
          alert('Se debe indicar un motivo.')
          return;
        }else{
          const api = new PwgsApi;
          const params = { motivo: this.motivoeliminacion };
          try { 
            await api.deletebody('facturas/' + this.$props.factura.factura.id_factura, params);
            if(this.$props.factura.error_xml?.valor == 1){
              this.$toast.add({ severity: 'success', summary: 'Enviada', detail: 'Registro eliminado correctamente', life: 2000 });
            }else{
              this.$toast.add({ severity: 'success', summary: 'Enviada', detail: 'Factura eliminado correctamente', life: 2000 });
            }
          } 
          catch (error) {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

          }
          this.$parent.cargardatosFactura();
        }
      },
      formatearFecha(timestamp) {
        if (!timestamp) return "-";
        const fecha = new Date(timestamp * 1000);

        const d = String(fecha.getDate()).padStart(2, '0');
        const m = String(fecha.getMonth() + 1).padStart(2, '0');
        const y = fecha.getFullYear();
        
        const h = String(fecha.getHours()).padStart(2, '0');
        const i = String(fecha.getMinutes()).padStart(2, '0');
        const s = String(fecha.getSeconds()).padStart(2, '0');

        return `${d}/${m}/${y} ${h}:${i}:${s}`;
      },
      async abrirFacturacionElba(){
            this.abriendoElba = true;
            try {
                const api = new PwgsApi();
                const resp = await api.get('servicios/' + this.servicio.id + '/gremios-elba');
                if (resp.urls && resp.urls.billing) {
                    window.open(resp.urls.billing, '_blank');
                } else {
                  this.$toast.add({ severity: 'warn', summary: "Este expediente no tiene enlace ELBA", life: 5000 });
                }
            } catch (e) {
              this.$toast.add({ severity: 'error', summary: 'No se ha podido conectar con ELBA. Intentalo de nuevo en unos minutos.', detail: e, life: 5000 });
            }
            this.abriendoElba = false;
        },
    },
    mounted() {
      //let aux = localStorage.getItem('direccion');
      this.obteneDocumentosFactura();
      this.datosurl = "";
      this.comprobarCodigo();
      this.cargardatos();
      this.cargarSeriesFacturacion();
      this.comprobarLeyantifraude();
    },
    watch: {
      servicio(){
        this.comprobarCodigo();
        this.cargarSeriesFacturacion();
      },
      yearActual(){
        this.siguientefactura(this.idserieseleccionada);
      },
      serieabonoseleccionada(nuevaSerie) {
        let serie = this.seriesfacturacion.find(
          s => s.id_serie === nuevaSerie
        );
        if(serie){
          this.siguienteabono = serie.siguiente_numero_abono;
        }else{
          serie = this.seriesfacturacion[0];
        }
        if(serie){
          this.serieabonoseleccionada = serie.id_serie;
          this.idserieseleccionada = serie.id_serie;
          this.siguientefactura(serie.id_serie);
        }
      },
      id() {
        this.cargardatos();
        this.cargarSeriesFacturacion();
      },
      togglecargar() {
        this.cargardatos();
      },
      correoseleccionado(value){
        this.correoEnvio = value;
      },
      emailSeleccionado:{
          handler(newVal) {
              Object.keys(newVal).forEach(idDoc => {
                  this.emailIntroducido[idDoc] = newVal[idDoc];
              });
          },
          deep: true
      }
    } 
  }
</script>
<style scoped>
.ribbon_cobrada {
  width: 90px;
  height: 90px;
  overflow: hidden;
  position: absolute;
}
.ribbon_cobrada::before,
.ribbon_cobrada::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #2980b9;
}
.ribbon_cobrada span {
  position: absolute;
  display: block;
  width: 165px;
  padding: 5px 0;
  background-color: #2980b9;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 10px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-transform: uppercase;
  text-align: center;
  z-index: 20;
}

.ribbon_no_cobrada {
  width: 90px;
  height: 90px;
  overflow: hidden;
  position: absolute;
}
.ribbon_no_cobrada::before,
.ribbon_no_cobrada::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #c42020;
}
.ribbon_no_cobrada span {
  position: absolute;
  display: block;
  width: 165px;
  padding: 5px 0;
  background-color: #d32c42;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 10px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-transform: uppercase;
  text-align: center;
  z-index: 20;
}


/* top right*/
.ribbon-top-right {
  top: -8px;
  right: -1px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 0;
}
.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}
.ribbon-top-right span {
  left: -25px;
  top: 30px;
  transform: rotate(45deg);
}


</style>